import { gql } from '@apollo/client';

export const SELECT_OWNER_SEAT = gql`
  mutation SelectOwnerSeat($seatType: String!) {
    selectOwnerSeat(seatType: $seatType)
  }
`; 